import qs from "qs";
import { _axios } from "./config";
import { IS_LOCAL_ENV } from "../App";

export const createResourceRecord = async (props) => {
  try {
    const { data } = await _axios.post(`/api/resourceConsumptions`, { ...props });
    return data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

export const getResourceHistory = async (page, sortProp, queryObj) => {
  const stringifiedQuery = Object.keys(queryObj).length
    ? qs.stringify({ where: queryObj })
    : "";

  try {
    const { data } = await _axios.get(
      `/api/resourceConsumptions?page=${page}` +
      (stringifiedQuery ? `&${stringifiedQuery}` : "") +
      (sortProp ? `&sort=${sortProp}` : "")
    );
    return data;
  } catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
};


export const getAllUsers = async () => {
  try {
    const { data } = await _axios.get(`/api/users?limit=0`);
    return data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}